import {Component, OnInit} from '@angular/core';
import {AlertService} from '@comm-apps/alert';
import { AggridService, AutoUnsubscribables, AutoUnsubscriber } from '@comm-apps/common';
import {LogService} from '@comm-apps/log';
import 'ag-grid-enterprise';
import {AppSettings} from '../../../app.settings';
import * as _ from 'lodash-es';
import {cad} from '@comm-apps/common';
import TableState = cad.TableState;
import { UserRequestData, CodeData, Asset, AssetRole } from '../../../core/classes/data-types';
import { CodeDataService } from '../../../services/code-data.service';
import { AccessRequestService } from '../../../services/access-request.service';
import { RecaptchaErrorParameters } from 'ng-recaptcha';

@Component({
  selector: 'car-pe-request',
  templateUrl: './pe-request.component.html',
  styleUrls: ['./pe-request.component.scss']
})
export class PEComponent implements OnInit  {
  @AutoUnsubscriber()
  protected subs: AutoUnsubscribables;
  private readonly blankData: UserRequestData = {applicationCd: 'PE', roles:[], companies:[{}], actionCd: 'add'};

  public actionOptions: any[] = [ {code:'add', description: 'Add User'}, 
                                  {code:'modify', description: 'Modify User'}, 
                                  {code:'remove', description: 'Remove User'}
                                ]

  public assets: Asset[] = [];
  public data:UserRequestData = _.cloneDeep(this.blankData);  
  public states: CodeData[] = [];
  public submitting: boolean = false;
  public submitted: boolean = false;

  constructor(
    protected alertService: AlertService,
    protected appSettings: AppSettings,
    protected log: LogService,
    protected codeService: CodeDataService,
    protected accessRequestService: AccessRequestService,
    protected gridService: AggridService,
  ) {
  }

  public ngOnInit(): void {
    this.getAssets();
    this.codeService.findByType('STATE').subscribe({
      next: (codes) => { this.states = codes; }
    });
  }

  private getAssets() {
    this.codeService.findByType('PE_ROLE').subscribe({
      next: (codes) => {
        const assets = [];
        codes.forEach(code => {
          const splitCode = code.code.split('-');
          const splitCodeDesc = code.description.split('|');
          const assetCd = splitCode[0];
          const assetName = splitCodeDesc[0];
          const roleName = splitCodeDesc[1];
          const businessArea = roleName.split(' ')[0];
          let asset = _.find(assets, { code: assetCd });
          if (!asset) {
            asset = {
              code: assetCd,
              name: assetName,
              roles: []
            };
            assets.push(asset);
          }
          asset.roles.push({
            code: code.code,
            name: roleName,
            businessArea,
            viewOnly: roleName.endsWith('View Only')
          });
        });
        this.assets = assets;
      }
    });
  }

  /**
   * Translates the selected check boxes into arrays of values on different properties on the source data object
   * @param event Checkbox event that is fired
   * @param role role associated with the checkbox clicked
   */
  public checkSelected(event: any, role: AssetRole) {
    const assetCd = role.code.split('-')[0];
    const asset = _.find(this.assets, { code: assetCd });
    if (event.checked) {
      this.data.roles.push({roleCd: role.code});
    } else {
      _.remove(this.data.roles, function(n) {return n.roleCd===role.code} );
    }

    const uncheckRole = r => {
      r.checked = false;
      _.remove(this.data.roles, function(n) {return n.roleCd===r.code} );
    }
    if (role.viewOnly) {
      _.filter(asset.roles, (r: AssetRole) => r.businessArea === role.businessArea && !r.viewOnly).forEach(r => {
        uncheckRole(r);
      })
    } else {
      const roleToRemove = _.find(asset.roles, (r: AssetRole) => r.businessArea === role.businessArea && r.viewOnly);
      uncheckRole(roleToRemove)
    }
  }

  public submit(): void {
    this.submitting = true;
    this.submitted = true;
    console.log('Recaptcha token is ', this.data.recaptchaToken);
    const propsToOmit = [];
    switch (this.data.actionCd) {
      case 'add':
        propsToOmit.push('userId');
        break;
      case 'remove':
        const props = ['comment', 'email', 'imId', 'phone', 'address', 'city', 'stateCd', 'zip', 'roles'];
        propsToOmit.push(...props);
    }
    if (this.data.primaryCompanyInd || this.data.actionCd == 'remove') {
      propsToOmit.push('primaryCompany');
    }
    const data: UserRequestData = _.omit(this.data, propsToOmit);
    if (data.actionCd == 'remove') {
      data.roles = [];
      data.primaryCompanyInd = true;
    }
    this.accessRequestService.savePublic(data).subscribe({
      error: () => {
        this.submitting = false;
        this.submitted = false;
      },
      complete: () => {
        this.submitting = false;
      }
    });
  }

  public clear(): void {
    const actionCd = this.data.actionCd;
    this.data = _.cloneDeep(this.blankData);
    this.data.actionCd = actionCd;
    this.assets.forEach(asset => {
      asset.roles.forEach(role => {
        role.checked = false;
      })
    });
    this.submitted = false;
    window.scroll(0, 0);
  }

  public resolved(captchaResponse: string): void {
    console.log(`Resolved captcha with response: ${captchaResponse}`);
  }

  public onError(errorDetails: RecaptchaErrorParameters): void {
    console.log(`reCAPTCHA error encountered; details:`, errorDetails);
  }

  public addCompany() {
    this.data.companies.push({ accessRequestId: this.data.id });
  }

  public deleteCompany(index: number) {
    this.data.companies.splice(index, 1);
  }



}
